import styled from "styled-components";
import { device } from "../../stylesheet/breakpoints";

type WraperProps = {
  addition_position_display?: number;
};

export const Wraper = styled.div<WraperProps>`
  position: relative;
  width: 100%;
  padding: 30px 10px 10px 10px;
  flex: 1;

  @media ${device.desktop} {
    ${({ addition_position_display }) =>
      addition_position_display === 2
        ? "padding: 20px 30px 10px 10px;"
        : "padding: 20px 10px 10px 30px;"}
  }
`;

export const ContentBox = styled.div`
  width: 100%;
  height: 100%;

  //@media ${device.desktop} {
    display: flex;
    flex-direction: column;
  //}
`;

export const Title = styled.h1`
  margin-bottom: 6px;
  text-align: inherit;
  font-weight: normal;
  font-size: 18px;
  line-height: 1.2;
  color: var(--title-text-color);

  @media ${device.desktop} {
    margin-bottom: 10px;
    font-size: 25px;
  }
`;

export const Text = styled.p`
  margin-bottom: 13px;
  text-align: inherit;
  font-weight: 400;
  font-size: 14px; //12
  line-height: 1.33;
  color: var(--text-color);

  @media ${device.desktop} {
    margin-bottom: 20px;
    line-height: 1.5;
  }
`;

export const Footer = styled.footer<WraperProps>`
  position: fixed;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100px;
  padding: 20px;
  background-color: rgba(var(--bg-color-rgb), 0.8);
  z-index: 1000;
  /* backdrop-filter: blur(5px); */

  @media ${device.desktop} {
    position: absolute;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    bottom: 0px;
    margin-bottom: -20px;
    padding: 30px;
    border-radius: 0px 0px 10px 0px;

    ${({ addition_position_display }) =>
      addition_position_display === 2 ? "left: 0" : ""}
  }
`;

type BonuseProps = {
  design_type?: number;
};

export const BoxContainer = styled.div<BonuseProps>`
  display: flex;
`;

export const BoxBonuse = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  height: 40px;
`;
